import React from 'react'

const NoMatchIcon = () => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="48" height="48" rx="24" fill="#D95C5C"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M30.7373 32.5362C31.2343 33.0332 32.0402 33.0332 32.5372 32.5362C33.0342 32.0392 33.0342 31.2333 32.5372 30.7363L25.8008 23.9999L32.5372 17.2635C33.0342 16.7665 33.0342 15.9606 32.5372 15.4636C32.0402 14.9666 31.2343 14.9666 30.7373 15.4636L24.0009 22.2L17.2645 15.4636C16.7674 14.9666 15.9616 14.9666 15.4646 15.4636C14.9675 15.9606 14.9675 16.7665 15.4646 17.2635L22.201 23.9999L15.4646 30.7363C14.9675 31.2333 14.9675 32.0392 15.4646 32.5362C15.9616 33.0333 16.7674 33.0333 17.2645 32.5362L24.0009 25.7998L30.7373 32.5362Z" fill="white"/>
	</svg>
) 

export default NoMatchIcon